import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { type } from 'os';

@Component({
  selector: 'app-coupons-sliders',
  templateUrl: './coupons-sliders.component.html',
  styleUrls: ['./coupons-sliders.component.css']
})
export class CouponsSlidersComponent implements OnInit {
  @Input() coupon: any;
  @Input() productCoupon: any;
  @Input() typeCode: number;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  public isProductCoupon: boolean = false;

  changeCouponSettings() {
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor() { }

  ngOnInit() {
    if (this.typeCode === 3 || this.typeCode === 4) {
      this.isProductCoupon = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupons-sliders.component.ts